import { render, staticRenderFns } from "./ordini.html?vue&type=template&id=2e68282a&scoped=true&"
import script from "./Ordini.vue?vue&type=script&lang=js&"
export * from "./Ordini.vue?vue&type=script&lang=js&"
import style0 from "./Ordini.vue?vue&type=style&index=0&id=2e68282a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68282a",
  null
  
)

export default component.exports